module.exports = __webpack_public_path__ + "static/media/Dr. Saif AlDeen.df683267.jpg";